import { Layout } from '../../components/Layout';

import { PageContent } from '../../components/PageContent';
import { TitleBlock } from '../../components/PageBlocks/TitleBlock';
import { JobsBlock } from 'components/PageBlocks/JobsBlock';
import CookiesPopup from 'components/CookiesPopup';

import styles from './index.module.scss';

import { RootState } from 'store/store';
import { useSelector } from 'react-redux';

const HackworkPage = () => {
	const mainData = useSelector((state: RootState) => state.data.data);
	const haltura = mainData.haltura;

	return (
		<Layout className={styles.page}>
			<PageContent>
				<TitleBlock className={styles.page__title} type='h1'>
					{haltura.name}
				</TitleBlock>
				<JobsBlock data={Object.values(haltura.images)[0]} />
			</PageContent>
			{!!mainData.config.file_policy_1 && (
				<CookiesPopup link={mainData.config.file_policy_1} />
			)}
		</Layout>
	);
};

export { HackworkPage };
